import * as React from 'react';
import { Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Layout } from '../../components/Layout';
import { DataTable } from '../../components/DataTable';
import { RouteModal } from '../../components/RouteModal';
import template from './DataTemplate';
import { useGetPagedAdsQuery } from '../../../services/gmoOfferwallApi';
import AddForm from './AddForm';
import EditForm from './EditForm';
import useFilterQuery from '../../../utils/customHooks/useFilterQuery';

export function OfferwallPage() {
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const {
    fieldFilter,
    setFieldFilter,
    search,
    setSearch,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    query,
  } = useFilterQuery(template);
  const paginatedQuery = `${query}${query ? '&' : ''}page=${page}&limit=${rowsPerPage}`;
  const { data, isFetching, error, isError } = useGetPagedAdsQuery(paginatedQuery);
  const offerwallCases = data?.data || [];
  const totalItems = data?.total || 0;

  React.useEffect(() => {
    setPage(1);
  }, [query]);

  return (
    <Layout title={'案件管理'}>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          component={RouterLink}
          to={'/OfferwallCsvPage'}
          variant="outlined"
        >
          CSV入出力
        </Button>
      </Box>
      <DataTable
        title={'案件管理'}
        data={offerwallCases}
        loading={isFetching}
        error={error}
        isError={isError}
        template={template}
        fieldFilter={fieldFilter}
        search={search}
        setFieldFilter={setFieldFilter}
        setSearch={setSearch}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        currentPageExternal={page}
        setCurrentPageExternal={setPage}
        rowsPerPageExternal={rowsPerPage}
        totalCountExternal={totalItems}
        disableClientPagination={true}
      />
      <RouteModal addForm={<AddForm />} editForm={<EditForm />} />
    </Layout>
  );
}

export default OfferwallPage;
